"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const enums_1 = require("./enums");
const constants_1 = require("./constants");
const builders_1 = require("./builders");
/**
 * Builds a GTM payload for valid Snowplow event. Returns null if the Snowplow event is not valid for GTM
 * @param payload Snowplow event payload that passes through the plugin
 */
const getGtmPayload = (payload) => {
    switch (getGtmSnowplowEvent(payload)) {
        case enums_1.GtmSnowplowEvent.PAGE_VIEW:
            return (0, builders_1.buildPageView)(payload);
        case enums_1.GtmSnowplowEvent.SR_SUBMIT:
            return (0, builders_1.buildSrSubmit)(payload);
        default:
            return null;
    }
};
/**
 * Determines the Snowplow Event and returns the corresponding GtmSnowplowEventEnum if this event is injected
 * @param payload Snowplow event payload that passes through the plugin
 */
const getGtmSnowplowEvent = (payload) => {
    var _a, _b, _c;
    if (payload.e === 'pv') {
        return enums_1.GtmSnowplowEvent.PAGE_VIEW;
    }
    else if (payload.e === 'ue') {
        // @ts-expect-error data does exist
        const eventSchema = (_c = (_b = (_a = JSON.parse(payload.ue_pr)) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.schema) !== null && _c !== void 0 ? _c : '';
        if (eventSchema.startsWith(constants_1.SR_SUBMIT_SCHEMA_SEARCH)) {
            return enums_1.GtmSnowplowEvent.SR_SUBMIT;
        }
    }
};
/**
 * Injects page_view and sr_submit events into the GTM dataLayer
 * @param payload Snowplow event payload that passes through the plugin
 */
const injectIntoDataLayer = (payload) => {
    try {
        const gtmPayload = getGtmPayload(payload);
        // @ts-expect-error snowplowDataLayer is a custom data layer name and not expected
        if (window.snowplowDataLayer !== undefined && gtmPayload !== null) {
            // @ts-expect-error snowplowDataLayer is a custom data layer name and not expected
            window.snowplowDataLayer.push(gtmPayload);
        }
    }
    catch (e) {
        console.log(e);
    }
};
/**
 * Custom JS plugin which injects all page_view and sr_submit events emitted from a tracker to the GTM data layer
 * Snowplow guide: https://docs.snowplow.io/docs/sources/web-trackers/plugins/creating-your-own-plugins/
 * Uses afterTrack so Snowplow event is sent to the emitter before executing this plugin to avoid any delays in Snowplow eventing
 */
const googleTagManagerDataInjectionPlugin = () => ({
    afterTrack: (payload) => {
        injectIntoDataLayer(payload);
    },
});
exports.default = googleTagManagerDataInjectionPlugin;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGx1Z2luLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL3BsdWdpbnMvY3VzdG9tL2dvb2dsZVRhZ01hbmFnZXJEYXRhSW5qZWN0aW9uL3BsdWdpbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUNBLG1DQUEyQztBQUUzQywyQ0FBc0Q7QUFDdEQseUNBQTBEO0FBRTFEOzs7R0FHRztBQUNILE1BQU0sYUFBYSxHQUFHLENBQUMsT0FBZ0IsRUFBcUIsRUFBRTtJQUMxRCxRQUFRLG1CQUFtQixDQUFDLE9BQU8sQ0FBQyxFQUFFO1FBQ2xDLEtBQUssd0JBQWdCLENBQUMsU0FBUztZQUMzQixPQUFPLElBQUEsd0JBQWEsRUFBQyxPQUFPLENBQUMsQ0FBQztRQUNsQyxLQUFLLHdCQUFnQixDQUFDLFNBQVM7WUFDM0IsT0FBTyxJQUFBLHdCQUFhLEVBQUMsT0FBTyxDQUFDLENBQUM7UUFDbEM7WUFDSSxPQUFPLElBQUksQ0FBQztLQUNuQjtBQUNMLENBQUMsQ0FBQztBQUVGOzs7R0FHRztBQUNILE1BQU0sbUJBQW1CLEdBQUcsQ0FBQyxPQUFnQixFQUFnQyxFQUFFOztJQUMzRSxJQUFJLE9BQU8sQ0FBQyxDQUFDLEtBQUssSUFBSSxFQUFFO1FBQ3BCLE9BQU8sd0JBQWdCLENBQUMsU0FBUyxDQUFDO0tBQ3JDO1NBQU0sSUFBSSxPQUFPLENBQUMsQ0FBQyxLQUFLLElBQUksRUFBRTtRQUMzQixtQ0FBbUM7UUFDbkMsTUFBTSxXQUFXLEdBQVcsTUFBQSxNQUFBLE1BQUEsSUFBSSxDQUFDLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSyxDQUFDLDBDQUFFLElBQUksMENBQUUsTUFBTSxtQ0FBSSxFQUFFLENBQUM7UUFDMUUsSUFBSSxXQUFXLENBQUMsVUFBVSxDQUFDLG1DQUF1QixDQUFDLEVBQUU7WUFDakQsT0FBTyx3QkFBZ0IsQ0FBQyxTQUFTLENBQUM7U0FDckM7S0FDSjtBQUNMLENBQUMsQ0FBQztBQUVGOzs7R0FHRztBQUNILE1BQU0sbUJBQW1CLEdBQUcsQ0FBQyxPQUFnQixFQUFRLEVBQUU7SUFDbkQsSUFBSTtRQUNBLE1BQU0sVUFBVSxHQUFHLGFBQWEsQ0FBQyxPQUFPLENBQUMsQ0FBQztRQUMxQyxrRkFBa0Y7UUFDbEYsSUFBSSxNQUFNLENBQUMsaUJBQWlCLEtBQUssU0FBUyxJQUFJLFVBQVUsS0FBSyxJQUFJLEVBQUU7WUFDL0Qsa0ZBQWtGO1lBQ2xGLE1BQU0sQ0FBQyxpQkFBaUIsQ0FBQyxJQUFJLENBQUMsVUFBVSxDQUFDLENBQUM7U0FDN0M7S0FDSjtJQUFDLE9BQU8sQ0FBQyxFQUFFO1FBQ1IsT0FBTyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQztLQUNsQjtBQUNMLENBQUMsQ0FBQztBQUVGOzs7O0dBSUc7QUFDSCxNQUFNLG1DQUFtQyxHQUFHLEdBQWtCLEVBQUUsQ0FBQyxDQUFDO0lBQzlELFVBQVUsRUFBRSxDQUFDLE9BQWdCLEVBQUUsRUFBRTtRQUM3QixtQkFBbUIsQ0FBQyxPQUFPLENBQUMsQ0FBQztJQUNqQyxDQUFDO0NBQ0osQ0FBQyxDQUFDO0FBRUgsa0JBQWUsbUNBQW1DLENBQUMifQ==


// WEBPACK FOOTER //
// ../../../../../src/plugins/custom/googleTagManagerDataInjection/plugin.ts